import React from 'react';
import {Link} from 'react-router-dom'

const ButtonLinkCharcoal = ({href,text,target}) => {

  return (
    <Link 
        to={href} 
        className='font-semibold text-center flex justify-center items-center bg-custom-charcoal text-white border-custom-charcoal rounded-md w-full min-h-[45px]'
        target={target || '_self'}
    >
        {text}
    </Link>
  );
};

export default ButtonLinkCharcoal;
